export default __webpack_public_path__ + "images/522c9ea1aa55609209d74a42fc184ae2.png";